import { exitFormalitie } from "./data/bgData";

export const recruitConstant={
    jobOpeningID:"Job Opening ID",
    postingTitle:"Posting Title",
    assignedRecruiter:"Assigned Recruiter",
    targetDate:"Target Date",
    city:"City",
    status:"Status",
    department:"Department",
    hiringManager:"Hiring Manager",
    actions:"Action",
    applicationName:"Application Name",
    currentLocation:"Current Location",
    applicationId:"Application ID",
    departmentID:"Department ID",
    departmentName:"Department Name",
    jobOpenings:"Job Openings",
    date:"Date",
    rating:"Rating",
    candidateStage:"Candidate Stage",
    candidateName:"Candidate Name",
    candidate:"Candidate",
    modifyTime:"Modify Time",
    source:"Source",
    candidateOwner:"Candidate Owner",
    application:"Applications",
    createApplication:"Create Application",
    jobOpeningId:"jobOpeningId",
    jobApplication:"Job Application",
    postingTitleAccessor:"postingTitle",
    assignedRecruiterAccessor:"assignedRecruiter",
    targetDateAccessor:"targetDate",
    createJobOpening:"Create job opening",
    jobProfile:"Job Profile",
    advanceSearch:"Advance Search",
    referrals:"referrals",
    statusAccessor:"status",
    state:"State",
    departmentAccessor:"department",
    hiringManagerAccessor:"hiringManager",
    action:"Action",
    candidates:"Candidates",
    interviewName:"Interview Name",
    from:"From",
    to:"To",
    candidatesName:"Candidate Name",
    jobtitle:"Job Title",
    referredBy:"Referred By",
    experience:"Experience",
    currentEmployer:"Current Employer",
    interviewOwner:"Interview Owner",
    createCandidates:"Create Candidate",
    interviews:"Interviews",
    departments:"Departments",
    campaigns:"Campaigns",
    campgain:"Campgain",
    offers:"Offers",
    offerLetter:"Offer Letter",
    campaignOwner:"Campaign Owner",
    createCampaign:"Create Campaign",
    type:"Type",
    campaignName:"Campaign Name",
    startDate:"Start Date",
    endDate:"End Date",
    expectedRevenue:"Expected Revenue",
    budgetCost:"Budget Cost",
    actualCost:"Actual Cost",
    expectedResponse:"Expected Response",
    numberSent:"Number Sent",
    deleteMsg:"Deleted successfully",
    next:"Next",
    back:"Back",
    save:"Save",
    cancel:"Cancel",
    update:"Update",
    description:"Description",
    enterDescription:"Enter description...",
    typeData:["Conference","Webinar","Public relations"],
    offer:"Offer",
    job:"Job",
    jobApplicant:"Job Applicant",
    addedBy:"Added By",
    offerExpireOn:"Offer Expire On",
    expectedJoiningDate:"Expected Joining Date",
    errorMsg:"Something went wrong",
    namePlaceHolderText:"Enter Name",
    name:"Name",
    emailPlaceHolderText:"Enter Email",
    email:"Email",
    phone:"Phone",
    phonePlaceHolderText:"Enter Phone",
    location:"Location",
    enterLocation: "Enter Location",
    totalExperience:"Total Experience",
    currentLocationLabel:"Current Location",
    noticePeriod:"Notice Period",
    applicationSource:"Application Source",
    selectTotalExp: "Select Total Experience",
    selectCurrentLocation: "Select Current Location",
    enterNoticePerios: "Enter Notice Period",
    selectStatus: "Select Status",
    selectApplicationSource: "Select Application Source",
    CoverLetter:"Cover Letter",
    attachment:"Attachment",
    panel:"Panel",
    panels:"Panels",
    panelName:"Panel Name",
    skills:"Skills",
    availability:"Availability",
    totalExprience:"Total Experience",
    noSkillsAdded:"No skills added",
    searchSkill:"Search or add a skill",
    maximumSkills:"Maximum 15 Skills",
    add:"Add",
    createPanel:"Create Panel",
    firstName:"First Name",
    lastName:"Last Name",
    submitPanel:"Submit",
    editSkills:"Edit Skills",
    showLess:"Show Less",
    showMore:"Show More",
    enterPanelName:"Enter panel name",
    panelFullName:"panelName",
    createJobOpenings:"Job Opening",
    createApplications:"Application",
    createCandidate: "Candidate",
    createInterView:"Interview",
    createReferral:"Referral",
    createDepartment:"Department",
    createCampaigns:"Campaign",
    bgVerification:"BG Verification",
    createBgVerification:"Create BG Verification",
    empId:"Emp ID",
    empName:"Emp Name",
    doj:"DOJ",
    createAt:"Create At",
    sharedAt:"Shared At",
    sharedTo:"Shared To",
    link:"Link",
    employeeID:"Employee ID",
    enterEmployeeID:"Enter Employee ID",
    companyName:"Company Name",
    enterCompanyName:"Enter company Name",
    location:"Location",
    lastDesignation:"Last Designation",
    enterLastDesignation:"Enter Last Designation",
    dateOfJoining:"Date of Joining",
    enterDepartment:"Enter Department",
    remunerationCTC:"Remuneration/CTC",
    enterremunerationCTC:"Enter Remuneration CTC",
    reasonsForLeaving:"Reasons For Leaving",
    enterReasonsForLeaving:"Enetr Resons For leaving",
    rolesAndResponsibility:"Roles And Responsibility",
    natureOfEmployment:"Nature Of Employment",
    exitFormalitiesCompleted:"Exit formalities completed",
    eligibleToReHire:"Eligible To Re-Hire",
    verifierName:"Verifier Name",
    verifierDesignation:"Verifier Designation",
    enterVerifierName:"Enter Verifier Name",
    enterVerifierDesignation:"Enter Verifier Designation ",
    verifierDetails:"Verifier Phone Number",
    enterVerifierDetails:"Enter Phone Number",
    permanent:"Permanent",
    anyPerformanceIntegrity:"Any Performance Integrity, or Disciplinary Issues",
    yes:"Yes",
    no:"No",
    enterReason:"Enter Reason",
    pleaseConfirmIf:"Please confirm if it is pending from company end or candidate end.",
    exitFormalitieText:"This is to confirm that all your exit formalities.",
    pleaseElaborate:" Please elaborate",
    pleaseSelect:"Please Select",
    createJobOpening:"Create Job Opening",
    jobOpening:"Job opening",
    postingTitle:"Posting Title",
    enterPostingTitle:"Enter Posting Title",
    departmentName:"Department Name",
    enterDepartmentName:"Enter department name",
    title:"Title",
    hiringManager:"Hiring Manager",
    assignedRecruiter:"Assigned Recruiter",
    numberOfPosition:"Number of Positions",
    enterNumber:"Enter Number",
    dateOpened:"Date Opened",
    jobOpeningStatus:"Job Opening Status",
    jobType:"Job Type",
    industry:"Industry",
    workExp:"Work Experience",
    salary:"Salary",
    requiredSkills:"Required Skills",
    enterReferral:"Enter Referral",
    enterFirstName:"Enter First Name",
    enterLirstName:"Enter Last Name",
    enterEmailId:"Enter Email ID",
    enterPhoneNumber:"Enter Phone Number",
    enterCurrentRole:"Enter Current Role",
    enterEmployer:"Enter Employer",
    delete: "Delete",
    statusUpdated:"Status updated successfully",
    someThingWentWrong: "Something went wrong",
    completed:"Completed",
    toDo: "To Do",  
    onHold: "On Hold",  
    inProgress: "In Progress",  
    pending: "Pending",
    referAcandidate: "Refer a candidate",
    createReferral: "Create Referral",
    more:"more"
    }
    